// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';
import { WarningOutlined } from '@ant-design/icons';

type Props = {
    visible: Boolean,
    cancel: Function,
    submit: Function,
    selectedType: String,
    closeModal: Function,
}

const ConfirmationModal = (props: Props) => {
  const {
    visible, cancel, submit, selectedType, closeModal,
  } = props;
  const type = {
    INDIVIDUAL: 'Individual',
    BUSINESS: 'Business',
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => closeModal()} type="danger">
          Close
        </SpButton>,
        <SpButton onClick={(e) => cancel(e)} type="secondary">
          Active Later
        </SpButton>,
        <SpButton onClick={(e) => submit(e)}>
          Start
        </SpButton>,
      ]}
      title="Welcome to Swirepay!"
    >
      <div className="px-4 pb-3" style={{ fontSize: 14, color: '#333' }}>
        <p>
          To activate your <span style={{ fontWeight: 'bold' }}>{type[selectedType]} Account</span>,
          we request you to have the following documents ready to upload:
        </p>
        <div style={{ marginBottom: 12 }}>
          <p><strong>Business Documents:</strong></p>
          <ul style={{ paddingLeft: 20 }}>
            <li>Void Check or Bank Letter</li>
          </ul>
          <p><strong>Personal Documents:</strong></p>
          <ul style={{ paddingLeft: 20 }}>
            <li>Govt ID (Driver&#39;s License, Passport, etc)</li>
          </ul>
        </div>

        <div style={{ display: 'flex', alignItems: 'start', marginBottom: 16 }}>
          <WarningOutlined style={{
            color: '#FF0000', marginRight: 8, marginTop: 7, fontSize: 25,
          }}
          />
          <span>
            Just checking us out? Sign in now and activate your account later in settings.
            Most features will be disabled until activation.
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
